import React, {  useMemo } from "react";
import _ from "lodash";
import normalizeString from "../../js/utilities/normalizeString";
import { usePublishersBooksData } from "../hooks/use-publishers-books";
import useIsMobile from "../../js/utilities/useIsMobile";
import { SwiperPublishersResponsive } from "./swiperPublishersResponsive";
import { SwiperPublishers } from "./swiperPublishers";

/**
 * Componente que retorna la fila con descripcion de las editoriales
 * @property {string} text - texto descriptivo
 * @property {array} books - arreglo de editoriales
 *  * @param {Object} props.navigationButtons - Referencias a los botones de navegación.
 * @returns {JSX.Element} DescriptiveRowPublishers
 */
export const DescriptiveRowPublishers = ({ text, navigationButtons }) => {
    const publishersData = usePublishersBooksData();
    const editoriales = useMemo(() => {
        return Array.isArray(publishersData.publishers) ? publishersData.publishers : []
    }, [publishersData.publishers]);

    const updateNavigation = (swiper) => {
        swiper.params.navigation.prevEl = navigationButtons?.prevButtonRef?.current
        swiper.params.navigation.nextEl = navigationButtons?.nextButtonRef?.current
        swiper.navigation.destroy()
        swiper.navigation.init()
        swiper.navigation.update()
    }

     const isMobile = useIsMobile();

    /**
    * Esta función transforma el nombre de la editorial en un parametro buscable 
    * @param {string} caracter //string: caracter que debe ser reemplazado por nuevoCaracter
    * @param {string} nuevoCaracter //string: nuevo caracter
    * @param {string} texto //string: nombre de la editorial
    * @returns 
    */
    const newUrlEditorial = (caracter, nuevoCaracter, texto) => {
        var buscarCaracter = texto.search(caracter);
        var newUrl;
        if (buscarCaracter === -1) {
            newUrl = normalizeString(texto).replace(caracter, nuevoCaracter);
            return newUrl;
        } else {
            return normalizeString(texto);
        }
    };

    return (
        <>
            <div className="swiper-editoriales-coleccion d-flex aling-items-center mt-2">
                <div className="w-100 d-flex">
                    <div className="d-none d-xl-block col-description px-0" style={{ height: 200 }}>
                        <p>{text}</p>
                    </div>
                    <div className="col-books px-0 pl-xl-3 pr-0" role="region" >
                        {
                            isMobile ?
                                <SwiperPublishersResponsive editoriales={editoriales}/>
                                :
                                <SwiperPublishers editoriales={editoriales}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
